import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class AccountingObjectAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'accountingObjects';

  /**
   * Get tất cả dữ liệu cán bộ
   * @returns
   */
  async getAllAccountingObject(param = {}) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/list',
      data: {
        Skip: 0,
        Take: 0,
        Sort: 'accounting_object_code',
        Columns:
          'accounting_object_code,accounting_object_name,accounting_object_id,contact_title,department_name,employee_type_name',
        Filter: '[{"Field":"is_employee","Value":true}]',
        type: 0,
        ...param,
        IsEmployee: true,
      },
    };

    return await httpClient.postAsync(request);
  }
  /**
   * Get tất cả dữ liệu cán bộ theo custom param truyền vào
   * ncdinh 23/11/2023
   * @returns
   */
  async getAllAccountingObjectCustom(dataCustom = {}) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/list',
      data: dataCustom,
    };

    return await httpClient.postAsync(request);
  }
  /**
   * Get tất cả dữ liệu nhà cung cấp
   * @returns
   */
  async getAllAccountingObjectNCC(param = {}) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/list',
      data: {
        Skip: 0,
        Take: 0,
        Sort: 'accounting_object_code',
        Columns:
          'accounting_object_code,accounting_object_name,accounting_object_id,contact_title,department_name,employee_type_name',
        Filter:
          '[{"Field":"is_employee","Operator":"NULL","Ors":[{"Field":"is_employee","Operator":"!=","Value":true}]}]',
        type: 0,
        ...param,
        IsEmployee: true,
      },
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Xuất khẩu grid danh sách cán bộ
   * TVANH 10.02.2023
   */
  exportEmployeeList(param) {
    let request = {
      url: window._apis[this.apiName] + '/Employees/ExportEmployeeList',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Get tất cả dữ liệu cán bộ
   * @returns
   */
  async getExportData(param = {}) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/GetDataExportEmployee',
      data: {
        Skip: 0,
        Take: 0,
        Columns:
          'accounting_object_code,accounting_object_name,accounting_object_id,contact_title,department_name,employee_type_name',
        Filter: '[{"Field":"is_employee","Value":true}]',
        type: 0,
        ...param,
        IsEmployee: true,
      },
    };

    return await httpClient.postAsync(request);
  }

  async getExportDataCustomer(param = {}) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/GetDataExportCustomer',
      data: {
        Skip: 0,
        Take: 0,
        Columns:
          'accounting_object_code,accounting_object_name,accounting_object_id,contact_title,department_name,employee_type_name',
        Filter: '[{"Field":"is_employee","Value":true}]',
        type: 0,
        ...param,
        IsEmployee: false,
      },
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Thực hiện cập nhật tỷ lệ BH, KPCĐ
   * nthien4 01.07.2022
   * @returns
   */
  async quickUpdateRate(param) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/updateRate',
      data: {
        ...param,
      },
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu form tham số báo cáo
   * HQMINH 22.09.2022
   * @param {} param
   * @returns
   */
  async getAllTargetsByReportID(param) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/getAllTargetsByReportID',
      data: {
        ...param,
      },
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy ra dữ liệu kh theo id
   * @param {*} payload
   * @returns
   */
  async getAccountDataByID(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/getDataByID',
      data: payload,
    };

    return await httpClient.getAsync(request);
  }

  async getClassificationType() {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/ClassificationType',
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Lấy dữ liệu danh sách tham số Giấy đề nghị thanh toán tạm ứng (TK 141)
   * @param {*} payload 
   * ntchuyen 21.12.2023
   */
   getListAccountingObject(payload){
    let request = {
      url: this.getAPIUrl() + '/accountingObjects',
      data: payload,
    };
    return httpClient.getAsync(request);
  }

  /**
   * lấy số dư tạm ứng
   * @returns
   *
   */
  async getAdvanceBalance(param) {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/AdvanceBalance',
      data: param,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Cập nhật KH,NCC, cán bộ thường xuyên sử dụng
   * @returns
   */
  async updateUsedRegularly() {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/updateUsedRegularly'
    };
    return await httpClient.postAsync(request);
  }

  async getAccountingObjectByTaxCode(taxCode){
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/filter?taxCode=' + taxCode
    };
    return await httpClient.getAsync(request);
  }

  async checkDuplicateObjectCode(objectCode){
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/existing?objectCode=' + objectCode
    };
    return await httpClient.getAsync(request);
  }

  async createAccountingObjectByAva(payload){
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/by-ava',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }
}

export default new AccountingObjectAPI();
